import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/common/BackButton";
import CustomiseSection from "../../components/collection/CustomiseSection";

// 1. The Individual Product Card Component
const EmbroideryCard = ({ product, onViewClick }) => {
    const [loupePos, setLoupePos] = useState({ x: 0, y: 0 });
    const [imagePos, setImagePos] = useState({ x: 0, y: 0 });
    const imageWrapperRef = useRef(null);

    // This function calculates the mouse position relative to the image container
    // and updates the position of the loupe circle and the image inside it.
    const handleMouseMove = (e) => {
        const { left, top, width, height } =
            imageWrapperRef.current.getBoundingClientRect();

        // Mouse coordinates relative to the wrapper
        const x = e.clientX - left;
        const y = e.clientY - top;

        // Update Loupe Position (centered on mouse)
        setLoupePos({ x, y });

        // Update magnified image position *inside* the loupe.
        // New Formula:
        // We want the point (x, y) on the small image to correspond to the center of the loupe.
        // The large image is at -x * scale, -y * scale relative to the origin.
        // We add loupeRadius to center that 'view' in the loupe div.

        const scale = 2.8; // Matches CSS width: 250%
        const loupeRadius = 90; // Matches CSS width/height: 180px / 2 = 90

        setImagePos({
            x: -(x * scale) + loupeRadius,
            y: -(y * scale) + loupeRadius,
        });
    };

    return (
        <div className="pe-card-wrapper">
            <div className="pe-card pe-static-card">
                {/* --- Image Wrapper with Mouse Tracking --- */}
                <div
                    className="pe-image-wrapper"
                    ref={imageWrapperRef}
                    onMouseMove={handleMouseMove}
                // On mouse leave, maybe reset? Optional, but feels smoother if left as is.
                >
                    {/* The "Base" Photo (Flat) */}
                    <img
                        src={product.imageBase}
                        alt={product.title}
                        className="pe-base-image"
                    />

                    {/* The Magnifying Loupe Circle */}
                    <div
                        className="pe-loupe"
                        style={{ top: `${loupePos.y}px`, left: `${loupePos.x}px` }}
                    >
                        {/* The "Textured" Embroidery Image inside the loupe */}
                        <img
                            src={product.imageTexture}
                            alt="Embroidery Detail"
                            className="pe-loupe-image"
                            style={{
                                transform: `translate(${imagePos.x}px, ${imagePos.y}px)`,
                            }}
                        />
                    </div>
                </div>

                {/* --- Card Details --- */}
                <div className="pe-details">
                    {/* Replaced Category with ID */}
                    <span className="pe-category">PRODUCT ID: {product.id}</span>
                    <h3 className="pe-title">{product.title}</h3>

                    <div className="pe-button-container">
                        <button className="pe-btn" onClick={() => onViewClick(product)}>Click to View</button>
                    </div>
                </div>
            </div>
        </div>
    );
};




// 2. Main Container displaying the grid
export default function GadgetAccessories() {
    const navigate = useNavigate();

    // DUMMY DATA - Replace with your real data
    // IMPT: Use real, high-res embroidery closeups for 'imageTexture'
    const products = [
        {
            id: 'GA-01',
            category: "Crochet AirPods Pouch",
            title: "Berry Buds Case",
            price: "₹ 349",
            imageBase: "images/acc2.webp",
            imageTexture: "images/acc2.webp",
            description: "A cute strawberry-inspired crochet pouch designed to safely hold your AirPods while adding a playful handmade touch.",
            highlights: ["Hand-crocheted pouch", "Secure fit for AirPods", "Soft yet protective texture"]
        },
        {
            id: 'GA-02',
            category: "Kids Crochet Pouches",
            title: "Flower Buds Case",
            price: "₹ 349",
            imageBase: "images/acc4.webp",
            imageTexture: "images/acc4.webp",
            description: "Colorful flower crochet pouches crafted for kids, perfect for storing earbuds or tiny treasures with charm.",
            highlights: ["Playful floral crochet", "Lightweight & durable", "Kid-friendly design"]
        },
    ];

    const handleViewProduct = (product) => {
        navigate('/product-view', { state: { product } });
    };

    return (
        <>
            <section className="pe-section">
                <div style={{ padding: "0 5%", maxWidth: "1200px", margin: "0 auto", marginTop: "20px" }}>
                    <BackButton />
                </div>
                <div className="pe-header">
                    <h2 className="pe-main-title">❖ Gadget Accessories Collection ❖</h2>
                    <div className="pe-thread-line"></div>
                    <p className="pe-subtitle">
                        A thoughtfully handcrafted diary, perfect for writing, reflecting, and gifting something truly personal.
                    </p>
                </div>

                <div className="pe-grid">
                    {products.map((product) => (
                        <EmbroideryCard key={product.id} product={product} onViewClick={handleViewProduct} />
                    ))}

                </div>
            </section>
            <CustomiseSection />
        </>
    );
}

